<template>
    <div class="">
        <div v-if="medicaments">
            <table class="table">
                <thead>
                <tr class="row m-0">
                    <th class="col-md-7">Lék</th>
                    <th class="col-md-1">Diagnóza</th>
                    <th class="col-md-1">Počet bal.</th>
                    <th class="col-md-1">Dávkování</th>
                    <th class="col-md-1">Opak.</th>
                    <th class="col-md-1"></th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(m, index) in medicaments" class="card-text">
                    <tr class="row m-0">
                        <td class="align-middle col-md-7">
                          {{ m.medicine ? m.medicine.label : '' }}
                          {{ m.individual_medicine ? m.individual_medicine.name : '' }}
                        </td>
                        <td class="align-middle col-md-1">
                            {{ m.disease !== null ? m.disease.code : ''}}
                        </td>
                        <td class="align-middle col-md-1">
                            {{ m.amount }}
                        </td>
                        <td class="align-middle col-md-1">
                            {{ m.dosage }}
                        </td>
                        <td class="text-left col-md-1">
                            {{ m.repeating }}

                        </td>
                        <td class="col-md-1 row justify-content-between m-0">
                            <button v-if="!deleteMedicamentPending" @click="removeMedicament(m.id)" class="btn btn-sm btn-danger btn_line-heigh-1"><i class="fa fa-trash-o" aria-hidden="true"></i></button>
                            <button class="btn btn-sm btn-danger disabled btn_line-heigh-1" v-else><i class="fa fa-trash-o" aria-hidden="true"></i></button>
                        </td>
                    </tr>
                    <tr class="row m-0">
                      <td class="col-md-8">
                        <small v-if="m.electronic_prescription === true" class="text_shown">ERecept</small>
                        <small v-else="" class="text_shown">Papírový</small> |
                        <small :class="m.paid_by_sick === true ? 'text_shown' : 'text_almost_hidden'">hradí pacient</small> |
                        <small :class="m.acute === true ? 'text_shown' : 'text_almost_hidden'">akutní</small> |
                        <small :class="m.family === true ? 'text_shown' : 'text_almost_hidden'">rodina</small> |
                        <small :class="m.separate === true ? 'text_shown' : 'text_almost_hidden'">samostatně</small> |
                        <small>notifikace: <span class="text_shown">{{ m.patient_notification_type }}</span></small> |
                        <small>platnost: <span class="text_shown">{{ m.validity_in_days }} dní</span></small>
                      </td>
                      <td class="col-md-4">
                        {{ m.note }}
                      </td>
                    </tr>
                </template>
                <template v-if="medicaments.length > 0">
                    <tr class="row m-0">
                        <td class="col-md-6"></td>
                        <td class="col-md-3"></td>
                        <td class="text-left col-md-3">
                            <button v-if="medicaments.length > 0" @click="generatePrescriptions()" class="btn btn-sm btn-success btn_line-heigh-1"><i class="fa fa-check" aria-hidden="true"></i> vytvořit recepty</button>
                            <button class="btn btn-sm btn-success disabled btn_line-heigh-1" v-else><i class="fa fa-check" aria-hidden="true"></i> vytvořit recepty</button>
                        </td>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>
        <div class="text-center" v-else-if="medicamentsPending">
            <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i><br/>
            (načítám)
        </div>
        <div class="text-center" v-else="">
            (žádný lék nebyl přidán)
        </div>
    </div>
</template>

<script>
  import apiMixin from '@/mixins'
  import ElectronicPrescription from '@/views/Client/modals/ElectronicPrescription.vue'

  export default {
    data () {
      return {
        hostname: require('@/variables.js'),
        // Prescriptions
        prescriptions: false,
        prescriptionsPending: false,
        prescriptionsError: false,
        // Medicaments
        medicaments: false,
        medicamentsPending: false,
        medicamentsError: false,
        medicamentsDone: false,
        // Medicament (delete)
        deleteMedicamentPending: false,
        deleteMedicamentDone: false,
        deleteMedicamentError: false,
        // second medicament
        secondMedicament: '',
        // single medicaments,
        selectedSeparatedIds: [],
        selectedEPrescriptionIds: [],
        allMedicamentIds: [],
        // post prescriptions
        postPrescriptionsPending: false,
        postPrescriptionsDone: false,
        postPrescriptionsError: false,
        // ePrescriptionModal
        modalEPrescriptionOpened: false
      }
    },
    props: ['doUpdate'],
    mixins: [apiMixin],
    computed: {
      unselectedSeparatedIds () {
        let ids = []

        for (let index = 0; index < this.medicaments.length; ++index) {
          if (this.selectedSeparatedIds.indexOf(this.medicaments[index].id) === -1) {
            ids.push(this.medicaments[index].id)
          }
        }

        return ids
      },
      recipeCount () {
        return this.selectedSeparatedIds.length + Math.ceil(this.unselectedSeparatedIds.length / 2)
      }
    },
    methods: {
      addToSelected (id) {
        if (this.selectedSeparatedIds.indexOf(id) === -1) {
          this.selectedSeparatedIds.push(id)
        }
      },
      removeFromSelected (id) {
        for (let index = 0; index < this.selectedSeparatedIds.length; ++index) {
          if (this.selectedSeparatedIds[index] === id) {
            this.selectedSeparatedIds.splice(index, 1)
          }
        }
      },
      addToSelectedEPrescription (id) {
        if (this.selectedEPrescriptionIds.indexOf(id) === -1) {
          this.selectedEPrescriptionIds.push(id)
        }
      },
      removeFromSelectedEPrescription (id) {
        for (let index = 0; index < this.selectedEPrescriptionIds.length; ++index) {
          if (this.selectedEPrescriptionIds[index] === id) {
            this.selectedEPrescriptionIds.splice(index, 1)
          }
        }
      },
      getAllMedicamentIds () {
        this.selectedSeparatedIds = []
        this.selectedEPrescriptionIds = []
        this.allMedicamentIds = []
        for (let i = 0; i < this.medicaments.length; i++) {
          this.allMedicamentIds.push(this.medicaments[i].id)
          this.addToSelected(this.medicaments[i].id)
          this.addToSelectedEPrescription(this.medicaments[i].id)
        }
      },
      copyMedicament (medicament) {
        this.$emit('copied', medicament)
      },
      removeMedicament (id) {
        this.secondMedicament = ''
        this.deleteMedicament(id)
        this.selectedSeparatedIds.splice(this.selectedSeparatedIds.indexOf(id), 1)
      },
      medicamentsListUpdated () {
        this.$emit('updated')
      },
      selectSecondMedicament (id) {
        this.secondMedicament = id
      },
      deselectSecondMedicament () {
        this.secondMedicament = ''
      },
      generatePrescriptions () {
        this.postPrescriptionsFromMedicamentsByVisit(this.$route.params.visitid)
      },
      showModal (name) {
        this.$modal.show(name)
      },
      updatePrescriptions () {
        this.$emit('prescription-created')
      }
    },
    watch: {
      doUpdate (val) {
        if (val === true) {
          this.getVisitUnprescribedMedicaments(this.$route.params.visitid)
          this.$emit('updated')
        }
      },
      deleteMedicamentDone (val) {
        if (val === true) {
          this.getVisitUnprescribedMedicaments(this.$route.params.visitid)
          this.deleteMedicamentDone = false
        }
      },
      '$route.params.visitid' () {
        this.secondMedicament = ''
        this.getVisitUnprescribedMedicaments(this.$route.params.visitid)
      },
      medicamentsDone (val) {
        if (val === true) {
          this.getAllMedicamentIds()
        }
      },
      postPrescriptionsDone (val) {
        if (val === true) {
          this.$emit('prescription-created')
        }
      }
    },
    beforeMount () {
      this.getVisitUnprescribedMedicaments(this.$route.params.visitid)
    },
    components: {
      ElectronicPrescription
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .table th, .table td {
        padding: 1px;
    }

    .no-top-border {
        border-top: none;
    }

    .btn_line-heigh-1 {
        line-height: 1;
    }

    .text_shown {
      font-weight: bolder;
    }

    .text_almost_hidden {
      font-weight: normal;
      color: #888888;
      text-decoration: line-through;
    }

</style>



// WEBPACK FOOTER //
// src/views/Visit/components/ListMedicament.vue?35e76fcc